"use client";

import Error400 from "@/components/error/400";
import image from "@/assets/errors/500.svg";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  if (error.cause && typeof error.cause === "number")
    return <Error400 statusCode={error.cause} onClick={reset} />;

  return (
    <Error400
      onClick={reset}
      customError={{
        title: error.name,
        subtitle: error.message,
        message: "",
        svg: image,
        buttonLabel: "reset",
      }}
    />
  );
}
